module.exports = __webpack_public_path__ + "static/media/facebook.e57c92e2.svg";